import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import * as St from './InformationDialog.styles';

interface InformationDialogProps {
  title?: string;
  icon?: JSX.Element;
  visible?: boolean;
  content: string;
  onClose: () => void;
}

const InformationDialog = ({
  title,
  icon,
  visible,
  content,
  onClose,
}: InformationDialogProps) => {
  const { t } = useTranslation();

  return (
    <St.Container
      centered
      destroyOnClose
      open={visible}
      closable={false}
      footer={null}
      onCancel={onClose}
    >
      <Row gutter={[0, 24]}>
        {title ? (
          <Col span={24}>
            <St.Title>{title}</St.Title>
          </Col>
        ) : null}

        <Col span={24}>
          <St.ContentContainer wrap={false} gutter={icon ? 16 : 0}>
            {icon ? <Col flex="none">{icon}</Col> : null}
            <Col flex="auto">
              <span>{content}</span>
            </Col>
          </St.ContentContainer>
        </Col>

        <Col span={24}>
          <St.DialogButton onClick={onClose}>
            {t('COMMON.CLOSE')}
          </St.DialogButton>
        </Col>
      </Row>
    </St.Container>
  );
};

export default InformationDialog;
